import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBathWoman1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bath-woman-1, women, female"} maskId="square-filled-radius-0-stroke-1-IconBathWoman1"><path d="M12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1Z" fill="currentColor"/><path d="M8.10528 8L5.36719 19.5H8.00021V23H16.0002V19.5H18.6332L15.8951 8H8.10528Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBathWoman1;
